import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";
import { useInfiniteQuery } from "@tanstack/react-query";

import { GetPendingActivitiesParams } from "api/generated/model";
import { getGetPendingActivitiesSuspenseInfiniteQueryOptions } from "api/generated/pending-activities/pending-activities";

interface DashboardPendingActivitiesParams {
    controlProgramIds?: number[];
    controlIds?: string[];
    dueDateStart?: string;
    dueDateEnd?: string;
    limit?: number;
    includeClaimedByOthers?: boolean;
}

function getDashboardPendingActivitiesQueryOptions(
    params: DashboardPendingActivitiesParams
) {
    const filterParams: GetPendingActivitiesParams = {
        ...(params.controlProgramIds !== undefined &&
            params.controlProgramIds.length > 0 && {
                control_program_ids: params.controlProgramIds,
            }),
        ...(params.controlIds !== undefined &&
            params.controlIds.length > 0 && {
                control_ids: params.controlIds,
            }),
        ...(params.dueDateStart !== undefined && {
            due_date_start: params.dueDateStart,
        }),
        ...(params.dueDateEnd !== undefined && {
            due_date_end: params.dueDateEnd,
        }),
        ...(params.limit !== undefined && {
            limit: params.limit,
        }),
        ...(params.includeClaimedByOthers !== undefined && {
            include_claimed_by_others: params.includeClaimedByOthers,
        }),
    };

    return getGetPendingActivitiesSuspenseInfiniteQueryOptions(filterParams, {
        query: {
            initialPageParam: "",
            getNextPageParam: (lastPage) => lastPage.data.pagination.next,
            select: (data) => {
                return {
                    content: data.pages.flatMap((page) => page.data.content),
                    linkedResources: null,
                    pagination: {
                        prev: null,
                        next: null,
                    },
                };
            },
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}

export function useDashboardPendingActivitiesQuery(
    params: DashboardPendingActivitiesParams
) {
    return useInfiniteQuery(getDashboardPendingActivitiesQueryOptions(params));
}
